import {API} from "@/Composables/api";

const getConversations = async (params = {}) => {
    return API.get(route("conversations.index"), params);
};

const getConversation = async (conversation: string, params = {}) => {
    return API.get(route("conversations.show", conversation), params);
};

const storeConversation = async (conversation, params = {}) => {
    return API.post(route("conversations.store"), params, conversation);
};

const toggleConversation = async (conversation, params = {}) => {
    return API.put(route("conversations.toggle", conversation), params);
};

const deleteConversation = async (conversation, params = {}) => {
    return API.delete(route("conversations.destroy", conversation), params);
};

const restoreConversation = async (conversation, params = {}) => {
    return API.post(route("conversations.restore", conversation), params);
};

const getAlbieConversation = async (params = {}) => {
    return API.get(route("conversations.ask_albie.show"), params);
};

const sendAlbieMessage = async (aiChatId: string, body: string) => {
    return API.post(route("conversations.ask_albie.messages.store", aiChatId), {}, {body});
};

const clearAlbieConversation = async (aiChatId: string) => {
    return API.delete(route("conversations.ask_albie.destroy", aiChatId), {});
};

export {
    getConversations,
    getConversation,
    storeConversation,
    toggleConversation,
    deleteConversation,
    restoreConversation,
    getAlbieConversation,
    sendAlbieMessage,
    clearAlbieConversation,
};
